export function formatInteger(value?: number | null) {
	if (value === undefined || value === null) {
		return "-";
	}
	return "" + value.toFixed(0);
}
